(() => {
  'use strict';
  const status = (now, start, end) => now < start ? 'upcoming' : now < end ? 'active' : 'ended';
  // Catalog holds originals. Estimate the one automatic discount independently of the countdown.
  const saleCents = cents => Math.round(Number(cents) * 0.7);
  const countdown = ms => {
    const seconds = Math.max(0, Math.floor(ms / 1000));
    return `${Math.floor(seconds / 86400)}d ${String(Math.floor(seconds / 3600) % 24).padStart(2, '0')}h ${String(Math.floor(seconds / 60) % 60).padStart(2, '0')}m ${String(seconds % 60).padStart(2, '0')}s`;
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = { status, saleCents, countdown }; return; }
  const source = document.getElementById('PKOpeningSaleConfig');
  if (!source) return;
  let config;
  try { config = JSON.parse(source.textContent); } catch (_) { return; }
  const start = Date.parse(config.startsAt), end = Date.parse(config.endsAt);
  const validClock = Number.isFinite(start) && Number.isFinite(end) && end > start;
  const eligible = product => Boolean(product?.id);
  const active = () => true;
  const renderPrice = (element, product, cents, format, prefix = '') => {
    const originalCents = Number(cents);
    const base = `${prefix}${format(originalCents)}`;
    element.removeAttribute('data-pk-sale-price');
    if (!Number.isFinite(originalCents) || originalCents <= 0) {
      element.textContent = base;
      return;
    }
    const original = document.createElement('s'), discounted = document.createElement('strong');
    original.textContent = base;
    discounted.textContent = `${prefix}${format(saleCents(originalCents))}`;
    element.classList.add('pk-sale-amount');
    element.replaceChildren(original, document.createTextNode(' '), discounted);
  };
  window.PKOpeningSale = Object.freeze({ config, eligible, active, status, saleCents, renderPrice });
  const updateText = (element, text) => {
    if (element.textContent === text) return;
    if (element.childNodes.length === 1 && element.firstChild.nodeType === Node.TEXT_NODE) element.firstChild.nodeValue = text;
    else element.textContent = text;
  };
  const renderClock = (clock, text) => {
    const values = text.match(/(\d+)d (\d+)h (\d+)m (\d+)s$/);
    const hoursOnly = !!clock.closest('.pk-inline-sale');
    const units = hoursOnly ? ['Hours', 'Min', 'Sec'] : ['Days', 'Hours', 'Min', 'Sec'];
    const displayValues = values && (hoursOnly ? [String(Number(values[1]) * 24 + Number(values[2])), values[3], values[4]] : values.slice(1));
    if (hoursOnly && displayValues) text = text.replace(/\d+d \d+h \d+m \d+s$/, `${displayValues[0]}h ${displayValues[1]}m ${displayValues[2]}s`);
    if (clock.getAttribute('aria-label') !== text) clock.setAttribute('aria-label', text);
    if (!values) { if (clock.childNodes.length) clock.replaceChildren(); return; }
    if (clock.querySelectorAll('.pk-sale-digit').length !== units.length) {
      const cells = units.map(unit => {
        const cell = document.createElement('span');
        const digit = document.createElement('span');
        const caption = document.createElement('span');
        cell.className = 'pk-sale-unit';
        digit.className = 'pk-sale-digit';
        caption.className = 'pk-sale-caption';
        caption.textContent = unit;
        cell.append(digit, caption);
        return cell;
      });
      clock.replaceChildren(...cells);
    }
    clock.querySelectorAll('.pk-sale-digit').forEach((digit, index) => {
      const value = displayValues[index].padStart(2, '0');
      updateText(digit, value);
    });
  };
  let previous;
  const update = () => {
    const now = Date.now(), state = validClock ? status(now, start, end) : 'ended';
    document.querySelectorAll('[data-pk-sale-timer]').forEach(timer => {
      const label = timer.querySelector('[data-pk-sale-label]'), clock = timer.querySelector('[data-pk-sale-clock]');
      if (label) updateText(label, '30% off · Automatically applied');
      if (clock) renderClock(clock, state === 'ended' ? '' : `${state === 'upcoming' ? 'Starts in ' : 'Ends in '}${countdown((state === 'upcoming' ? start : end) - now)}`);
      timer.removeAttribute('data-pk-sale-ended');
    });
    if (previous && previous !== state) document.dispatchEvent(new CustomEvent('pk:opening-sale-state', { detail: { state } }));
    previous = state;
  };
  update();
  setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
})();
